export default "/images/vendor/flag-icons/flags/4x3/re.svg?9d72b568db01dfb982e8dee01a86d235";